export function nonEmptyStringOrExisting<T extends string | undefined>(
  value: string | null | undefined,
  existing: T
): T | string {
  return value?.trim() ? value : existing;
}

export function nonEmptyArrayOrExisting<T>(
  value: T[] | null | undefined,
  existing: T[] | undefined
) {
  return value && value.length > 0 ? value : existing;
}
